<div class="modal-container">
  <button
    id="modalTitulo"
    #modalTitulo
    data-bs-toggle="modal"
    data-bs-target="#modelND"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modelND"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">Editar título</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="dominioForm" (ngSubmit)="submitForm()">
            <div class="row">
              <div
                *ngFor="let field of tituloForm"
                class="col-md-{{ field.width }}">
                <div class="mb-3">
                  <label
                    *ngIf="field.visible"
                    [for]="field.name"
                    class="form-label"
                    >{{ field.label
                    }}<span
                      *ngIf="field.required"
                      _ngcontent-ng-c3465959523=""
                      class="text-danger">
                      *</span
                    ></label
                  >
                  <!-- Text Input -->
                  <input
                    *ngIf="field.type === 'text'"
                    [id]="field.name"
                    [type]="field.type"
                    class="form-control"
                    [formControlName]="field.name" />
                  <!-- Textarea -->
                  <textarea
                    *ngIf="field.type === 'textarea' && field.visible"
                    [id]="field.name"
                    class="form-control"
                    [formControlName]="field.name"
                    rows="3"></textarea>
                  <!-- Validation Error Messages -->
                  <div *ngIf="getErrorMessage(field.name)" class="text-danger">
                    {{ getErrorMessage(field.name) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 d-flex gap-2">
              <button type="submit" class="btn-govco fill-btn-govco">
                Guardar
              </button>
              <button
                type="button"
                class="btn-govco btn-govco"
                data-bs-dismiss="modal">
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
